// extracted by mini-css-extract-plugin
export default {"warningBox":"styles_warningBox__mQZfi"};